// extracted by mini-css-extract-plugin
export default {"offer":"offer---IkXrt"};